import PortalBidsList from "../../components/admin/portalBids/PortalBidsList";

const PortalBids = () => {
  return (
    <>
      <PortalBidsList />
    </>
  );
};
export default PortalBids;
